export default __webpack_public_path__ + "static/media/programmer.5d66d452.jpg";